module.exports = __webpack_public_path__ + "img/fengcai4.90ff924b.png";